module.exports = __webpack_public_path__ + "static/media/present_christmas_map.f270f41b.svg";